// import Vuex from 'vuex'
// import modules from '@/store/modules'

// export default new Vuex.Store({
//     modules: {
//         ...modules
//     }
// })

import { createStore } from 'vuex'
import modules from '@/store/modules'

const store = createStore({
    modules: {
        ...modules
    }
});


export default store;

